import React from "react";
import { Button, } from "antd";

import "./ChangePassword.less";
import { updatePassword } from "services/rest/request";
import { useIntl } from "react-intl";

export function ChangePassword() {
  const intl = useIntl();

  return (
    <>
      <div className="account-settings__title">
        {intl.formatMessage({ id: "jmix-account.change-password.title" })}
      </div>
      <div className="change-password__content">
        <Button
          ghost
          type="primary"
          onClick={updatePassword}
        >
          {intl.formatMessage({ id: "jmix-account.change-password.button" })}
        </Button>
        <div className="change-password__description">
          {intl.formatMessage({ id: "jmix-account.change-password.description" })}
        </div>
      </div>
    </>
  );
}
